/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import TabHead from 'material/tabs/tab/tabhead/tabhead';
import TabContent from 'material/tabs/tab/tabcontent/tabcontent';
// styles
import injectSheet from 'react-jss';
import styles from 'material/tabs/tabs_styles';



/* ========== ~~~~~~~~~~ TABS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Tabs extends Component {
	constructor(props) {
		super(props);
		this.state = { activeTab: this.props.children[0].props.id }; // set first child as active tab
	}
	setActiveTab = (activeTab) => this.setState({ activeTab: activeTab }); // this function is passed into tabhead component, which has an onclick that passes back a value to here so we can set state, which will update a property that is passed to tabcontent component and render appropriate content (that's a helluva round trip huh)
	isActiveTab = (tab) => tab.props.id === this.state.activeTab;
	render() {
	    return(
	    	<div id={this.props.id} className={`tabs ${this.props.classes.tabs}`}>
		    	<div className={`tabheader`}>
		    		{this.props.children.map(tab => <TabHead key={tab.props.id} id={tab.props.id} title={tab.props.title} isActive={this.isActiveTab(tab)} setActiveTab={this.setActiveTab} />)}
		    	</div>
		    	<div className={`tabbody`}>
		    		{this.props.children.map(tab => <TabContent key={tab.props.id} id={tab.props.id} isActive={this.isActiveTab(tab)}>{tab.props.children}</TabContent>)}
		    	</div>
	        </div>
	    );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Tabs);
